import React from 'react';
import { Grid, Card, CardContent, Typography, Box, Container, useTheme, Divider } from '@mui/material';

// Updated feature data reflecting the company's journey in the UK
const milestones = [
  {
    title: 'Our Founding',
    description: 'Founded in 2023 in the UK, we embarked on a mission to bring innovative software solutions to businesses across Europe and beyond. Starting with a small, passionate team, we aimed to make a big impact on the industry.',
    icon: '🏁',
    bgColor: '#BBDEFB',
  },
  {
    title: 'First Major Project',
    description: 'Our first major project in 2023 was a landmark moment for the company. It helped us build lasting relationships with clients in the UK and across Europe, laying the foundation for future growth.',
    icon: '🚀',
    bgColor: '#C8E6C9',
  },
  {
    title: 'Expansion into Global Markets',
    description: 'In 2025, we expanded our reach beyond the UK, delivering our innovative services to clients in North America, Asia, and the Middle East. This marked a significant milestone in our growth strategy.',
    icon: '🌍',
    bgColor: '#FFECB3',
  },
  {
    title: 'Technological Advancements',
    description: 'Adopting the latest technologies in 2025, we integrated AI, machine learning, and cloud services to improve our solutions. Our focus on innovation has kept us ahead of industry trends and enabled us to meet diverse client needs.',
    icon: '💻',
    bgColor: '#E1F5FE',
  },
  {
    title: 'Recognition and Awards',
    description: 'In 2025, we were recognised as one of the leading tech companies in the UK, earning prestigious awards for innovation and customer service. This recognition further validated our hard work and commitment to excellence.',
    icon: '🏆',
    bgColor: '#FFCCBC',
  },
  {
    title: 'Commitment to Excellence',
    description: 'Today, we continue to build on our success in the UK and internationally. With a growing team of talented professionals, we remain committed to delivering cutting-edge solutions and exceptional service to our clients worldwide.',
    icon: '🌟',
    bgColor: '#FFF59D',
  },
];

const StoryAboutUS = () => {
  const theme = useTheme();

  return (
    <Box sx={{ py: 5, backgroundColor: '#f9f9f9' }}>

      <Container>
        {/* Title Section */}
        <Typography
          variant="h3"
          align="center"
          id='journey'
          sx={{
            color: theme.palette.secondary.main,
            fontWeight: 'bold',
            marginBottom: 3,
            fontSize: '2.5rem',
            letterSpacing: '1px',
          }}
        >
          Our Journey
        </Typography>

        {/* Description Section */}
        <Typography
          variant="body1"
          align="center"
          sx={{
            color: '#666',
            marginBottom: 6,
            fontSize: '1.1rem',
            maxWidth: '800px',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          From our humble beginnings in the UK to becoming a trusted name in the global software industry, our journey has been driven by innovation, dedication, and a commitment to solving complex business challenges. We’ve grown through hard work, passion, and the trust of our clients and partners.
        </Typography>

        {/* Divider */}
        <Divider sx={{ marginBottom: 6 }} />

        {/* Milestones Grid */}
        <Grid container spacing={5} justifyContent="center">
          {milestones.map((milestone, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  backgroundColor: milestone.bgColor,
                  borderRadius: 4,
                  boxShadow: '0 10px 20px rgba(0, 0, 0, 0.15)',
                  textAlign: 'center',
                  height: '100%',
                  transition: 'transform 0.3s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-10px)',
                    boxShadow: '0 12px 24px rgba(0, 0, 0, 0.2)',
                  },
                }}
              >
                <CardContent sx={{ padding: 4 }}>
                  {/* Milestone Icon */}
                  <Box
                    sx={{
                      fontSize: '50px',
                      marginBottom: 2,
                      color: theme.palette.primary.dark,
                    }}
                  >
                    {milestone.icon}
                  </Box>

                  {/* Milestone Title */}
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 'bold',
                      marginBottom: 1,
                      color: theme.palette.secondary.dark,
                    }}
                  >
                    {milestone.title}
                  </Typography>

                  {/* Milestone Description */}
                  <Typography
                    variant="body2"
                    sx={{
                      color: '#444',
                      lineHeight: 1.7,
                      fontSize: '1rem',
                    }}
                  >
                    {milestone.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default StoryAboutUS;
